import { IndustryTypeEnumType } from '__generated__/graphql';

export default function industryToReadable(industry: IndustryTypeEnumType): {
  label: string;
  color: string;
} {
  if (!industry) {
    return {
      label: 'Unknown',
      color: 'gray',
    };
  }

  switch (industry as IndustryTypeEnumType) {
    case IndustryTypeEnumType.Logistics:
      return { label: 'Logistics', color: 'gray' };
    case IndustryTypeEnumType.SaasEnterprise:
      return { label: 'SaaS/Enterprise', color: 'gray' };
    case IndustryTypeEnumType.FinancialServicesFintech:
      return { label: 'Fintech', color: 'gray' };
    case IndustryTypeEnumType.Gaming:
      return { label: 'Gaming', color: 'gray' };
    case IndustryTypeEnumType.Retailtech:
      return { label: 'RetailTech', color: 'gray' };
    case IndustryTypeEnumType.Healthtech:
      return { label: 'HealthTech', color: 'gray' };
    case IndustryTypeEnumType.ConsumerBrands:
      return { label: 'Consumer Brands', color: 'gray' };
    case IndustryTypeEnumType.Services:
      return { label: 'Services', color: 'gray' };
    case IndustryTypeEnumType.Edtech:
      return { label: 'EdTech', color: 'gray' };
    case IndustryTypeEnumType.SocialEntertainment:
      return { label: 'Social/Entertainment', color: 'gray' };
    case IndustryTypeEnumType.Agritech:
      return { label: 'AgriTech', color: 'gray' };
    case IndustryTypeEnumType.TravelAndHospitality:
      return { label: 'Travel & Hospitality', color: 'gray' };
    case IndustryTypeEnumType.Ai:
      return { label: 'AI', color: 'gray' };
    case IndustryTypeEnumType.EvMobility:
      return { label: 'EV/Mobility', color: 'gray' };
    case IndustryTypeEnumType.Ecommerce:
      return { label: 'E-Commerce', color: 'gray' };
    case IndustryTypeEnumType.Deeptech:
      return { label: 'DeepTech', color: 'gray' };
    case IndustryTypeEnumType.Proptech:
      return { label: 'PropTech', color: 'gray' };
    case IndustryTypeEnumType.MarketplacePlatform:
      return { label: 'Marketplace/Platform', color: 'gray' };
    case IndustryTypeEnumType.Cleantech:
      return { label: 'CleanTech', color: 'gray' };
    case IndustryTypeEnumType.FAndB: // adjust if codegen names this differently
      return { label: 'F&B', color: 'gray' };
    case IndustryTypeEnumType.Other:
      return { label: 'Other', color: 'gray' };
    case IndustryTypeEnumType.Hardware:
      return { label: 'Hardware', color: 'gray' };
    case IndustryTypeEnumType.Health:
      return { label: 'Health', color: 'gray' };
    case IndustryTypeEnumType.Healthcare:
      return { label: 'Healthcare', color: 'gray' };
    case IndustryTypeEnumType.HomeServices:
      return { label: 'Home Services', color: 'gray' };
    case IndustryTypeEnumType.HumanResourcesRecruiting:
      return { label: 'HR/Recruiting', color: 'gray' };
    case IndustryTypeEnumType.IndustrySpecificSaas:
      return { label: 'Industry Specific SaaS', color: 'gray' };
    case IndustryTypeEnumType.Insurance:
      return { label: 'Insurance', color: 'gray' };
    case IndustryTypeEnumType.InvestmentPlatforms:
      return { label: 'Investment Platforms', color: 'gray' };
    case IndustryTypeEnumType.Iot:
      return { label: 'IoT', color: 'gray' };
    case IndustryTypeEnumType.MediaEntertainment:
      return { label: 'Media & Entertainment', color: 'gray' };
    case IndustryTypeEnumType.Payments:
      return { label: 'Payments', color: 'gray' };
    case IndustryTypeEnumType.Productivity:
      return { label: 'Productivity', color: 'gray' };
    case IndustryTypeEnumType.RealEstate:
      return { label: 'Real Estate', color: 'gray' };
    case IndustryTypeEnumType.Retail:
      return { label: 'Retail', color: 'gray' };
    case IndustryTypeEnumType.Robotics:
      return { label: 'Robotics', color: 'gray' };
    case IndustryTypeEnumType.SalesTools:
      return { label: 'Sales Tools', color: 'gray' };
    case IndustryTypeEnumType.Security:
      return { label: 'Security', color: 'gray' };
    case IndustryTypeEnumType.Social:
      return { label: 'Social', color: 'gray' };
    case IndustryTypeEnumType.SocialImpact:
      return { label: 'Social Impact', color: 'gray' };
    case IndustryTypeEnumType.Transportation:
      return { label: 'Transportation', color: 'gray' };
    case IndustryTypeEnumType.Travel:
      return { label: 'Travel', color: 'gray' };
    case IndustryTypeEnumType.VrAr:
      return { label: 'VR/AR', color: 'gray' };
    default:
      return {
        label: industry.toString().replace(/_/g, ' ') ?? 'Unknown',
        color: 'gray',
      };
  }
}
